import React from "react";
import { Dropdown, Menu } from "antd";
import { AiOutlineEdit } from "react-icons/ai";

interface RoleItemProps {
  item: {
    name?: string;
    [key: string]: any;
  };
  index: number;
  handleEditRole: Function;
}

const RoleItem: React.FC<RoleItemProps> = ({ item, handleEditRole }) => {
  const menu = (
    <Menu>
      <Menu.Item key="edit" onClick={() => handleEditRole(item)}>
        <AiOutlineEdit style={{ marginRight: "6px", color: "#3182ce" }} />
        Edit
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown
      overlay={menu}
      trigger={["hover"]}
      overlayClassName="access-rights-cell-menu"
      mouseEnterDelay={0.2}
    >
      <div className="access-rights-role-header">
        <span className="access-rights-role-dot" />
        {item?.name}
      </div>
    </Dropdown>
  );
};

export default RoleItem;
